import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    height: 70,
  },
  label: {
    marginLeft: 5,
    marginBottom: 10,
  },
  root: {
    '& .MuiMenu-paper': {
      borderRadius: 8,
      width: '100%',
      height: 56,
    },
  },
  errorText: {
    marginTop: 5,
    marginLeft: 14,
    color: theme.palette.colors.red,
  },
  item: {
    '&.MuiListItem-button': {
      '&:hover': {
        backgroundColor: theme.palette.colors.lightTeal,
      },
    },
  },
  icon: {
    top: 'calc(50% - 6px)',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Select/useStyles.js